import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import theme from "theme";

export const FontAwesomeIconWithTheme = (props) => <FontAwesomeIcon {...props} color={theme.palette.primary.main} />;
